<app-stage>
  <div class="not-found-wrapper">
    <div class="not-found-image"></div>
    <h4 class="not-found-title">Whoops! Page Not Found</h4>
    <p class="hint"><a class="link" routerLink="/">Click here</a> to see the events you're registered for.</p>
    <p class="hint"><a class="link" href="https://www.revnt.io/">Click here</a> to go to our home page.</p>
  </div>
</app-stage>
